// extracted by mini-css-extract-plugin
export default {"page":"ChooseDocument_page__Qrx-s"};